export const ProjectTheme = {
    font: {
        fontSize: {
            default: '22px',
            h1: '40px',
            h2: '30px',
        },
        lineHeight: {
            default: '24px',
            h1: '50px',
            h2: '36px',
        },
        fontFamily: {
            default: 'Roboto Condensed, sans-serif',
            h1: 'Futura',
            h2: 'Futura',
        },
    },
    colors: {
        primaryBackground: 'white',
        secondaryBackground: 'lightgray',
        primaryText: '#212529',
        secondaryText: 'white',
        highlightText: '#FFCC01',
        highlightBackground: '#5B5B5B',
    },
    margin: {
        extraSmallMargin: '5px',
        smallMargin: '10px',
        mediumMargin: '20px',
        largeMargin: '40px',
        extraLargeMargin: '400px',
    },
    padding: {
        extraSmallPadding: '5px',
        smallPadding: '15px',
        mediumPadding: '30px',
        largePadding: '150px',
        extraLargePadding: '400px',
    },
    mobileWidth: {
        maxWidth: '700px',
        minWidth: '701px',
    },
    button: {
        fontWeight: '400',
        fontSize: '1rem',
        padding: '0.375rem 0.75rem',
        backgroundColor: '#FFCC00',
        hoverBackgroundColor: '#ecbd00',
        activeBackgroundColor: '#ecbd00',
        borderColor: '#FFCC00',
        hoverBorderColor: '#ecbd00',
        activeBorderColor: '#ecbd00',
        textColor: 'white',
        border: '1px solid transparent',
        borderRadius: '0.25rem',
        transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    },
    input: {
        fontWeight: '400',
        fontSize: '1rem',
        padding: '0.375rem 0.75rem',
        backgroundColor: 'white',
        hoverBackgroundColor: 'white',
        activeBackgroundColor: 'white',
        borderColor: '#FFCC00',
        hoverBorderColor: '#ecbd00',
        activeBorderColor: '#ecbd00',
        textColor: '#212529',
        border: '1px solid transparent',
        borderRadius: '0.25rem',
        transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    },
    radio: {
        backgroundColor: 'white',
        hoverBackgroundColor: 'white',
        checkedBackgroundColor: 'white',
        textColor: '#212529',
        hoverTextColor: '#212529',
        activeTextColor: '#212529',
    }
};
//# sourceMappingURL=Theme.js.map